import { render, staticRenderFns } from "./AreaCard.vue?vue&type=template&id=fd60f61e"
import script from "./AreaCard.vue?vue&type=script&lang=js"
export * from "./AreaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports